
import { DataTable } from "./data-table"

import type { TableViewProps } from "@univdiam/ui/lib/SharedTypes"



export default function OrderListTable(
  { data, handleOrderOpen, globalFilter, setGlobalFilter, sorting,
    setSorting,
    columnVisibility,
    setColumnVisibility, isAdmin, onUpdateOrder, adminTags, fetchTags, page, setPage, pagination }: TableViewProps & { page?: number, setPage?: any, pagination?: any }) {

  return (
    <div className="border-b boder-[#EBEBED] bg-white overflow-clip">
      <DataTable  {...{
        data, handleOrderOpen, globalFilter, setGlobalFilter, sorting,
        setSorting,
        columnVisibility,
        setColumnVisibility, isAdmin, onUpdateOrder, adminTags, fetchTags, page, setPage, pagination
      }} />
    </div>
  )
}
